const ActivityEvent = {
  onSearch: 'activity/on-search'
}

export default ActivityEvent
